<template>
  <v-app>
    <v-snackbar
      v-model="snackbar"
      timeout="2000"
      top
      color="bg-gradient-success"
    >
      {{ actionstatus }}
      <template v-slot:action="{ attrs }">
        <v-btn
          class="font-weight-bold"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Xааx
        </v-btn>
      </template>
    </v-snackbar>
    <v-container class="my-6 mx-auto" fluid>
      <h5 class="font-weight-bold text-h5 text-typo mb-0">Irz monitoring</h5>
      <v-progress-linear
        v-if="loading"
        color="red"
        height="6"
        indeterminate
      ></v-progress-linear>
      <v-card class="border-radius-xl card-shadow">
        <v-data-table
          v-if="errordIrzuud && errordIrzuud.length > 0"
          :headers="headers"
          :items="errordIrzuud"
          hide-details
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:item.dayDate="{ item }">
            <span>{{ _getDatee(item) }} - {{ item.dayDate }}</span>
          </template>

          <!-- <template v-slot:item.dayDate2="{ item }">
            <span v-if="item.docRef">{{ item.docRef.path }}</span>
          </template> -->

          <template v-slot:item.teacherInfo="{ item }">
            <span v-if="item.teacherInfo" style="cursor: pointer;">
              {{ item.teacherInfo["USERNAME"] }}
              {{ item.teacherInfo["DATE_OF_BIRTH"].replace("T00:00:00.000Z","")}}</span
            >
            <v-btn icon><v-icon @click="_copyy(item.teacherInfo)">mdi-content-copy</v-icon></v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");
// import moment from "moment";
import { sync } from "vuex-pathify";
export default {
  data: () => ({
    actionstatus: null,
    snackbar: false,
    loading: false,
    errordIrzuud: null,
  }),
  computed: {
    ...sync("*"),
    ...mapState(["userProfile", "currentUser"]),

    headers() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
          width: "2%",
        },
        {
          text: "schoolName",
          align: "start",
          value: "schoolName",
          sortable: true,
        },
        {
          text: "className",
          align: "start",
          value: "className",
          sortable: true,
        },
        {
          text: "dayDate",
          align: "start",
          value: "dayDate",
          sortable: true,
        },
        {
          text: "dayDate2",
          align: "start",
          value: "dayDate2",
          sortable: true,
        },
        {
          text: "newVersion",
          align: "start",
          value: "newVersion",
          sortable: true,
        },
        {
          text: "teacherInfo",
          align: "start",
          value: "teacherInfo",
          sortable: true,
        },
      ];
    },
  },
  created() {
    fb.db
      .collection("_errors_daily_irz-2024")
      .orderBy("schoolName", "asc")
      .where("dayDate", "==", "2025-04-14")
      .onSnapshot((docs) => {
        this.errordIrzuud = [];
        var counter = 0;
        docs.forEach((doc) => {
          counter++;
          let irz = doc.data();
          irz.id = doc.id;
          irz.ref = doc.ref;
          irz.existing = null;

          irz.index = counter;
          irz.teacherInfo = null;

          irz.classGroupRef.get().then((doc) => {
            irz.teacherID = doc.data().TEACHER_ID;
            irz.school = irz.classGroupRef.parent.parent.parent.parent.path;
            // console.log(irz.school,"ss");
            irz.classGroupRef.parent.parent.parent.parent
              .collection("teachers")
              .doc(String(irz.teacherID))
              .get()
              .then((doc) => {
                irz.teacherInfo = doc.data();
                console.log("teacherDATA", doc.data());
              });
            // /schools/9xsMs3WvJxfCVHR2sJJq/teachers/9000000827760
          });

          this.errordIrzuud.push(irz);
          // console.log(doc.data());
        });
      });
  },
  methods: {
    _copyy(teacherInfo){
      var xx =
      teacherInfo.USERNAME + " " + teacherInfo["DATE_OF_BIRTH"].replace("T00:00:00.000Z","")
      navigator.clipboard
        .writeText(xx)
      this.actionstatus = xx
      this.snackbar = true
    },
    _getDatee(dd) {
      var xx = new Date(dd.dayDate);
      var dooc =
        xx.getFullYear() + "-" + (xx.getMonth() + 1) + "-" + xx.getDay();
      return dooc;
    },
    _getDatee2(dd) {
      var xx = new Date(dd.dayDate);
      var dooc = xx.getFullYear() + "-" + xx.getMonth() + "-" + xx.getDay();
      if (dd.classGroupRef) {
        dd.classGroupRef
          .collection("attendances-2024")
          .doc(dooc)
          .onSnapshot((doc) => {
            dd.existing = doc.data();
            dd.existing.id = doc.id;
            dd.existing.ref = doc.ref;
            dd.exists = doc.exists;
          });
      }
    },
  },
};
</script>
